/**
 * @desc 通过月份同步历史邮件
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(mailAccountCode: string | number, month: string | number, options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/sync/month/${mailAccountCode}/${month}`, {
      method: "POST",

      ...options,
    }),
  );
}
